import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';

import { BdcService } from '../../../services/service-bdc.service';

@Component({
  selector: 'app-liste-piece-a-commander',
  templateUrl: './liste-piece-a-commander.component.html',
  styleUrls: ['./liste-piece-a-commander.component.scss']
})
export class ListePieceACommanderComponent implements OnInit {

  listeBdc = [];

  constructor(private BdcService: BdcService, private router: Router, private httpClient: HttpClient) { }

  ngOnInit(): void {
    this.BdcService.getListBdcPieceACommander().then((listeACommander: any) => {
      this.listeBdc = listeACommander;
    });


  }

}
